export enum TripSort {
    OVERALL = "Preferred",
    TIME = "Arrival",
    DURATION = "Duration",
    PRICE = "Price",
    CARBON = "Greener",
    CALORIES = "Healthiest"
}